var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"savings-installer"},[(_vm.cta)?_c('a',{staticClass:"cta link icon--next btn",attrs:{"href":_vm.cta.url,"target":_vm.cta.target}},[_vm._v(_vm._s(_vm.cta.text))]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link link--installer",attrs:{"href":"/consument/vind-een-installateur"}},[_c('i',{staticClass:"icon icon--fitter"}),_vm._v("Vind een installateur")])
}]

export { render, staticRenderFns }